import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Typography, Paper } from '@mui/material';
import { useAuth } from '../../context/AuthContext';

export default function AdminRoute() {
  const { isAdmin, loading, authMode } = useAuth();

  // Bypass mode: always allow (bypass user is admin)
  if (authMode === 'bypass') {
    return <Outlet />;
  }

  if (loading) return null;

  if (!isAdmin) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 8 }}>
        <Paper sx={{ p: 4, maxWidth: 400, textAlign: 'center' }}>
          <Typography variant="h6" gutterBottom>Access Denied</Typography>
          <Typography color="text.secondary">
            You don't have administrator permissions to view this page.
          </Typography>
        </Paper>
      </Box>
    );
  }

  return <Outlet />;
}
